import PageHero from '@/components/PageHero';
import { GlassCard } from '@/components/ui/glass-card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Calendar, BookOpen, Clock, CheckCircle } from 'lucide-react';

const Module = () => {
  const modules = [
    {
      number: 1,
      title: "Basis Modul",
      duration: "2 Tage",
      prerequisites: "Keine Vorkenntnisse nötig",
      description: "Im Modul 1 lernst du wirksame Techniken zur Aktivierung der Selbstheilungskräfte in dir und bei anderen Menschen. Du lernst die Energiefelder des Menschen zu fühlen, auszugleichen und körperliches Gleichgewicht wieder herzustellen.",
      topics: [
        "Fühlen und Messen der Aura und Chakren (Energiekörper und Energiezentren)",
        "Arbeiten mit verschiedenen Energie-Arten",
        "Transformieren und Energetisieren des Energiekörpers",
        "Körperliche Anatomie",
        "Krankheit verstehen und die Symptomatik richtig deuten können",
        "Transformations- und Selbstheilungsprozesse starten und beschleunigen",
        "Selbstheilungstechniken",
        "Fern-Anwendungen, Anwendungen auf Distanz",
        "Bereinigen von Fremdenergien",
        "Meditation",
        "Verbindung zur eigenen Seele stärken",
        "Ausrichten auf das eigene Potenzial und den Seelenplan"
      ]
    },
    {
      number: 2,
      title: "Erweiterung Basis Modul",
      duration: "2 Tage",
      prerequisites: "Absolviertes Modul 1",
      description: "Im Modul 2 wird das Wissen und die Technik des 1. Moduls vertieft und kann von dir bereits auf seelisch-geistiger Ebene angewendet werden. Du lernst die Organe der Seele kennen, sie zu erfühlen und die Wurzel aller Disharmonie zu bereinigen.",
      topics: [
        "Erweitertes Fühlen und Messen der Aura und Chakren",
        "Erspüren der Organe der Seele",
        "Arbeiten mit den höchsten Energien",
        "Erweiterte Techniken der Bereinigung und Stärkung der Organe der Seele",
        "Erkennen und Auflösen der Wurzel von Krankheit und anderen Blockaden",
        "Seelisch-geistige Anatomie",
        "Erweiterung der Fern-Anwendung",
        "Reinigen und Programmieren von Gegenständen",
        "Reinigen und Energetisieren von Räumen und Objekten",
        "Aktivieren der eigenen Inneren Sinne, erweiterte Wahrnehmungen",
        "Harmonisches Aktivieren der eigenen 'Spirituellen Lebenskraft'",
        "Lebenskraft-Meditation und Seelenbewusstsein"
      ]
    },
    {
      number: 3,
      title: "Lebensbaum",
      duration: "2 Tage",
      prerequisites: "Absolviertes Modul 2",
      description: "Im Modul 3 kommt die Prana Kundalini-Therapie® in ihre nächste Stufe. Hier lernst du deinen seelischen Lebensbaum kennen. Der seelische Lebensbaum öffnet den Zugang zu allen Schöpfungswelten, die in jeder Seele enthalten sind.",
      topics: [
        "Zugang zu den 11 Inneren Ebenen der Seele",
        "Umgang mit den göttlich-geistigen Kräften in jeder Ebene",
        "Lösen aller karmischen Verhärtungen der Seele",
        "Der menschliche Körper, ein göttliches Wunderwerk",
        "Zugang zu seinem eigenen 'Inneren Schöpferzentrum'",
        "Steigerung der tiefen Freude und des Inneren Friedens",
        "Seelisch-geistige Freiheit und Erfüllung"
      ]
    },
    {
      number: 4,
      title: "Spirituelle Lebenskraft Aktivierung",
      duration: "2 Tage",
      prerequisites: "Absolviertes Modul 3",
      description: "Im Modul 4 kommt die Prana Kundalini-Therapie® voll zur Wirkung. Hier lernst du mit deiner eigenen spirituellen Lebenskraft erstaunliche Selbstheilungsprozesse bei dir auszulösen.",
      topics: [
        "Harmonisches Aktivieren und Stabilisieren der spirituellen Lebenskraft",
        "Körperbewusstsein, Organbewusstsein und Zellbewusstsein",
        "Berichtigung der Information von Krankheit in Organen, Zellen und DNS",
        "Ausgleichen aller Energiekörper über die spirituelle Lebenskraft",
        "Öffnen aller Chakren und Erreichen eines ausgeglichenen Bewusstseins",
        "Bereinigen des Unterbewusstseins und der Wurzel aller Krankheit",
        "Stärkung und Integration wahrer, geistiger Gedanken und Sichtweisen",
        "Aktivieren der Herzensqualitäten und geistigen Fähigkeiten",
        "Erweiterung des Bewusstseins und der Wahrnehmung",
        "Integration aller verdrängten Wesensteile der Seele - Ganzwerdung",
        "Erkennen des eigenen Seelenplans",
        "Aktivieren der spirituellen Schöpferkraft nach höherer Absicht",
        "Gottesfunken - Meditation"
      ]
    },
    {
      number: 5,
      title: "Solar Torus®",
      duration: "2 Tage",
      prerequisites: "Absolviertes Modul 4",
      description: "Im Modul 5 Solar Torus® gelangst du wieder in direkten Kontakt mit deinem Bewusstseinsfeld. In diesem Torus-Energiefeld können alle schadhaften Programme und Traumen der Vergangenheit sofort bereinigt werden.",
      topics: [
        "Reinigung und Belichtung des Unterbewusstseins",
        "Aktivierung des elektromagnetischen Torusfeldes - dein Bewusstsein",
        "Arbeit mit den Platonischen Körpern",
        "Arbeit mit dem Torus der Menschen",
        "Erkennen der Einheit mit dem Kosmos",
        "Öffnung der Zell-DNS für Geist-Nahrung",
        "Öffnung für die Inneren Dimensionen des Herzens",
        "Manifestation des im Leben innewohnenden Planes",
        "Spirituelle Lebenskraft - Meditation und Torus-Meditation"
      ],
      hasExam: true
    }
  ];

  return (
    <>
      <PageHero 
        title="Module" 
        description="Der gesamte Lehrgang der Prana Kundalini-Therapie® beinhaltet folgende Module"
        image="https://images.unsplash.com/photo-1518495973542-4542c06a5843"
      />
      
      <section className="py-20 bg-primary-lightest">
        <div className="container mx-auto px-4">
          <div className="space-y-16">
            {modules.map((module) => (
              <GlassCard key={module.number} className="p-8 bg-white/90 border-white/30">
                <div className="grid lg:grid-cols-3 gap-8">
                  {/* Module Header */}
                  <div className="lg:col-span-1 space-y-4">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="w-16 h-16 bg-primary-main text-white rounded-full flex items-center justify-center text-2xl font-bold">
                        {module.number}
                      </div>
                      <div>
                        <h2 className="text-2xl font-bold text-primary-deep">
                          Prana Kundalini-Therapie® Modul {module.number}
                        </h2>
                        <h3 className="text-xl font-semibold text-gray-800">
                          {module.title}
                        </h3>
                      </div>
                    </div>
                    
                    <div className="space-y-2">
                      <div className="flex items-center space-x-2 text-gray-600">
                        <Clock className="h-4 w-4" />
                        <span>Dauer: {module.duration}</span>
                      </div>
                      <div className="flex items-center space-x-2 text-gray-600">
                        <BookOpen className="h-4 w-4" />
                        <span>Inklusive Skripten</span>
                      </div>
                      <div className="text-sm text-gray-500">
                        Voraussetzung: {module.prerequisites}
                      </div>
                    </div>

                    {module.hasExam && (
                      <div className="bg-orange-100 border border-orange-300 rounded-lg p-4">
                        <div className="flex items-center space-x-2 text-orange-800">
                          <CheckCircle className="h-5 w-5" />
                          <span className="font-semibold">Schriftliche und mündliche Prüfung</span>
                        </div>
                        <p className="text-sm text-orange-700 mt-1">
                          Abschließende Zertifizierung (Dauer: 2h)
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Module Content */}
                  <div className="lg:col-span-2 space-y-6">
                    <p className="text-gray-700 leading-relaxed">
                      {module.description}
                    </p>

                    <div>
                      <h4 className="text-lg font-semibold text-primary-deep mb-4">
                        Inhalte des Moduls:
                      </h4>
                      <ul className="grid md:grid-cols-2 gap-2">
                        {module.topics.map((topic, index) => (
                          <li key={index} className="flex items-start space-x-2">
                            <CheckCircle className="h-4 w-4 text-primary-main mt-1 shrink-0" />
                            <span className="text-gray-700 text-sm">{topic}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </GlassCard>
            ))}
          </div>

          {/* CTA Section */}
          <div className="text-center mt-16">
            <GlassCard className="p-8 max-w-2xl mx-auto bg-white/90 border-white/30">
              <h3 className="text-2xl font-bold text-primary-deep mb-4">
                Bereit für Ihre spirituelle Reise?
              </h3>
              <p className="text-primary-deep mb-6">
                Beginnen Sie Ihre Ausbildung zum zertifizierten Prana Kundalini Therapeuten
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button asChild size="lg" className="bg-primary-main hover:bg-primary-deep">
                  <Link to="/seminartermine">
                    <Calendar className="mr-2 h-5 w-5" />
                    Termine ansehen
                  </Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="border-primary-main text-primary-main hover:bg-primary-main hover:text-white">
                  <Link to="/anmeldung">
                    <BookOpen className="mr-2 h-5 w-5" />
                    Jetzt anmelden
                  </Link>
                </Button>
              </div>
            </GlassCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default Module;